import Form, { Context } from "./form-component";
// import createForm from "./form-class.txt";
import createBuilder from "./form-builder";
import gravityFormAdaptor from "./adaptor/gravity-forms";

export default Form;
export { Context, createBuilder, gravityFormAdaptor };
export * from "./types";
